<template>
<div class="ls-table-wrapper">
    <div class="ls-table-inner" ref="tableInner">
    <table class="ls-table">
      <thead>
        <tr>
          <th v-for="h in tableLayout.header"><div class="cell-inner">{{ h.label }}</div></th>
        </tr>
      </thead>
      <tbody v-if="tableData.length">
        <tr v-for="r in tableDataSlice">
          <td v-for="h in tableLayout.header"><div class="cell-inner">{{ r[h.key] }}</div></td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td :colspan="tableLayout.header.length" class="row-no-data">No data available</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="ls-table-pagination">
    <button class="btn btn-primary" :disabled="currentPage == 0" @click="currentPage--"><i class="fa fa-arrow-left"></i> prev</button> | 
    <button class="btn btn-primary" :disabled="currentPage >= lastPage" @click="currentPage++">next <i class="fa fa-arrow-right"></i></button>
    <span v-if="lastPage >= 0">page {{ currentPage + 1 }} of {{ lastPage + 1 }} &nbsp; <small>({{ tableData.length }} records)</small></span>
  </div>
</div>
</template>


<script>

export default {
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    tableLayout: {
      type: Object,
      default: function () {
        return { header: [] };
      }
    },
    bcOptions: {
      type: Object,
      default: function () {
        return {};
      }
    },
    searchOn: {
      type: Object,
      default: function () {
        return null;
      }
    }
  },
  computed: {
      pageSize() {
      return (this.tableData.length % 10) >= 3 ? 10 : 10 + (this.tableData.length % 10);
    },
    
      showPagination() {
      return this.tableData.length > this.pageSize;
    },
    lastPage() {
      return Math.ceil(this.tableData.length / this.pageSize) - 1;
    },
    tableDataSlice() {
      var cursor = this.currentPage * this.pageSize;
      return this.tableData.slice(cursor, cursor + this.pageSize);
    }
  },
  data: function () {
    // var defaultPageSize = (this.tableData.length % 10) >= 3 ? 10 : 10 + (this.tableData.length % 10);
    
    return {
      defaultOptions: {
        displayModeBar: false
      },
//      pageSize: defaultPageSize,
      currentPage: 0
    };
  },
  watch: {
    tableData: function (current, old) {
      this.currentPage = 0;
    }
  },
  methods: {
    mergeDicts: function (defaultDict, newDict) {
      for (var key in this.newDict) {
        defaultDict[key] = this.newDict; 
      }
      return defaultDict;
    }
  }
};
</script>


<style lang="scss" scoped>
  $inside-border: 1px solid #666;
  $strong-border: 2px solid #666;
  $head-background: #f1f1f1;

  .ls-table-wrapper {
    display: flex;
    flex-direction: column;


    .ls-table-inner {
      overflow-y: auto;
      flex: 1;
      
      table.ls-table {
        font-family: "Roboto Mono", "Inconsolata", monospace;
        font-size: 90%;
        border-collapse: collapse;
        width: 100%;  
        border-bottom: $strong-border;
        
        .cell-inner {
          line-height: 2em;
          margin: auto;
          padding: 1px 4px;
          height: 100%;
          width: 100%;
          overflow: hidden;
          display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
          vertical-align: bottom;
        }
        
        
        thead {
          border-bottom: $strong-border;
          
          th {
            text-align: center;
            border-right: $inside-border;
            vertical-align: middle;
            background-color: $head-background;
            padding: 10px;

            &:first-child {
              text-align: left;
            }
            
            &:last-child {
              border-right: none;
            }
          }
        }
        
        tbody {
          tr {          
            border-bottom: $inside-border;
            
            td {
              text-align: right;
              border-right: $inside-border;
              
              &:first-child {
                text-align: left;
                background-color: $head-background;
                font-weight: 700;
              }
              &:last-child {
                border-right: none;
              }
              &.row-no-data {
                padding: 20px;
                text-align: center;
                background-color: initial;
              }
            }
          }
        }
      }
    }
    
    .ls-table-pagination {
      flex: 0;
      width: 100%;
      background: #fafafa;
      padding: 10px 4px;
      
      button.btn {

        
        /* &:disabled { */
        /*   color: #bbb; */
        /*   text-decoration: none; */
        /* } */
      }
    }
  }
  
</style>



// WEBPACK FOOTER //
// LsStatsTable.vue?0f2db449